'use strict';

export default [
  {
    name: 'Contact us',
    model: 'Contact',
    id: 1,
    path: 'contact',
  },
];



// WEBPACK FOOTER //
// ./client/models/global/Authed.js